import makeActionCreator from './makeActionCreator';
import * as actionTypes from './actionTypes';

// Create your Action Creators here...
export const fetchEventDetails = makeActionCreator(actionTypes.FETCH_EVENT, 'eventId', 'forceRefresh');
export const fetchEventDetailsLoading = makeActionCreator(actionTypes.FETCH_EVENT_LOADING);
export const fetchEventDetailsSuccess = makeActionCreator(actionTypes.FETCH_EVENT_SUCCESS, 'event',
  'collection');
export const fetchEventDetailsError = makeActionCreator(actionTypes.FETCH_EVENT_ERROR, 'error',
  'collectionError');
export const fetchEventDetailsDone = makeActionCreator(actionTypes.FETCH_EVENT_DONE);

// Local cache of event details and stats
export const applyCachedEvent = (eventId, data) => ({
  type: actionTypes.USE_CACHED_EVENT,
  eventId,
  data
});

export const storeEventCache = (eventId, data, fetchedAt) => ({
  type: actionTypes.STORE_EVENT_CACHE,
  eventId,
  data,
  fetchedAt
});

export const fetchEventStatsSuccess = makeActionCreator(actionTypes.FETCH_EVENT_STATS_SUCCESS, 'stats');
export const fetchEventStatsError = makeActionCreator(actionTypes.FETCH_EVENT_STATS_ERROR, 'error');

export const fetchEventLayoutSuccess = makeActionCreator(actionTypes.FETCH_EVENT_LAYOUT_SUCCESS, 'layout');
export const fetchEventLayoutError = makeActionCreator(actionTypes.FETCH_EVENT_LAYOUT_ERROR, 'error');

export const fetchEventIdeasSuccess = makeActionCreator(actionTypes.FETCH_IDEAS_SUCCESS, 'ideas');
export const fetchEventIdeasError = makeActionCreator(actionTypes.FETCH_IDEAS_ERROR, 'error');

export const fetchEventPulsesSuccess = makeActionCreator(actionTypes.FETCH_PULSES_SUCCESS, 'pulseStats');
export const fetchEventPulsesError = makeActionCreator(actionTypes.FETCH_PULSES_ERROR, 'error');

export const fetchEventRosterSuccess = makeActionCreator(actionTypes.FETCH_ROSTER_SUCCESS, 'roster');
export const fetchEventRosterError = makeActionCreator(actionTypes.FETCH_ROSTER_ERROR, 'error');

export const fetchEventSentimentByRatingSuccess = makeActionCreator(actionTypes.FETCH_SENTIMENT_BY_RATING_SUCCESS, 'sentimentByRating');
export const fetchEventSentimentByRatingError = makeActionCreator(actionTypes.FETCH_SENTIMENT_BY_RATING_ERROR,
  'error');

export const updateEventLayout = makeActionCreator(actionTypes.UPDATE_EVENT_LAYOUT, 'eventId', 'sections');
export const updateEventLayoutLoading = makeActionCreator(actionTypes.UPDATE_EVENT_LAYOUT_LOADING);
export const updateEventLayoutSuccess = makeActionCreator(actionTypes.UPDATE_EVENT_LAYOUT_SUCCESS, 'layout');
export const updateEventLayoutError = makeActionCreator(actionTypes.UPDATE_EVENT_LAYOUT_ERROR, 'error');
export const updateEventLayoutDone = makeActionCreator(actionTypes.UPDATE_EVENT_LAYOUT_DONE);

export const attachRoster = makeActionCreator(actionTypes.ATTACH_ROSTER, 'eventId', 'rosterId');
export const attachRosterLoading = makeActionCreator(actionTypes.ATTACH_ROSTER_LOADING);
export const attachRosterSuccess = makeActionCreator(actionTypes.ATTACH_ROSTER_SUCCESS, 'event');
export const attachRosterError = makeActionCreator(actionTypes.ATTACH_ROSTER_ERROR, 'error');
export const attachRosterDone = makeActionCreator(actionTypes.ATTACH_ROSTER_DONE);

export const fetchEventsAndPrioritize = makeActionCreator(actionTypes.FETCH_EVENTS_AND_PRIORITIZE);
export const fetchEventsAndPrioritizeStart = makeActionCreator(actionTypes.FETCH_EVENTS_AND_PRIORITIZE_START);
export const fetchEventsAndPrioritizeLoading = makeActionCreator(actionTypes.FETCH_EVENTS_AND_PRIORITIZE_LOADING);
export const fetchEventsAndPrioritizeSuccess = makeActionCreator(actionTypes.FETCH_EVENTS_AND_PRIORITIZE_SUCCESS, 'payload');
export const fetchEventsAndPrioritizeError = makeActionCreator(actionTypes.FETCH_EVENTS_AND_PRIORITIZE_ERROR, 'error');
export const fetchEventsAndPrioritizeDone = makeActionCreator(actionTypes.FETCH_EVENTS_AND_PRIORITIZE_DONE);

export const syncFetchEventsAndPrioritize = makeActionCreator(actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE);
export const syncFetchEventsAndPrioritizeStart = makeActionCreator(actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE_START);
export const syncFetchEventsAndPrioritizeLoading = makeActionCreator(actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE_LOADING);
export const syncFetchEventsAndPrioritizeSuccess = makeActionCreator(actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE_SUCCESS, 'payload');
export const syncFetchEventsAndPrioritizeError = makeActionCreator(actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE_ERROR, 'error');
export const syncFetchEventsAndPrioritizeDone = makeActionCreator(actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE_DONE);

export const fetchEventStats = makeActionCreator(actionTypes.FETCH_EVENT_STATS, 'payload');
export const fetchEventStatsStart = makeActionCreator(actionTypes.FETCH_EVENT_STATS_START, 'payload');
export const fetchEventStatsDone = makeActionCreator(actionTypes.FETCH_EVENT_STATS_DONE, 'payload');
export const fetchEventStatsNewSuccess = makeActionCreator(actionTypes.FETCH_EVENT_STATS_NEW_SUCCESS, 'payload');

export const deleteEventOrPrioritize = makeActionCreator(actionTypes.DELETE_EVENT_OR_PRIORITIZE, 'payload');
export const deleteEventOrPrioritizeStart = makeActionCreator(actionTypes.DELETE_EVENT_OR_PRIORITIZE_START, 'payload');
export const deleteEventOrPrioritizeSuccess = makeActionCreator(actionTypes.DELETE_EVENT_OR_PRIORITIZE_SUCCESS, 'payload');
export const deleteEventOrPrioritizeError = makeActionCreator(actionTypes.DELETE_EVENT_OR_PRIORITIZE_ERROR, 'payload');
export const deleteEventOrPrioritizeDone = makeActionCreator(actionTypes.DELETE_EVENT_OR_PRIORITIZE_DONE, 'payload');
